import React from "react";
import data from "../Journey/data";
// import { ReactComponent as Continents } from './continents.svg';
import { ReactComponent as Continents } from "./countries.svg";
import "./index.css";

// const regions = ['EAF', 'us', 'SAM', 'EU', 'SAS', 'MEA']
const regions = [
  "SAM",
  "WAF",
  "NAF",
  "EAF",
  "SAF",
  "EU",
  "SAS",
  "EAS",
  "AFG",
  "MEA",
  "us",
];

export default function Map(props) {
  const { setContinent, setCategory } = props;

  const mapRef = React.useRef(null);
  const containerRef = React.useRef(null);

  const [targetContinent, setTargetContinent] = React.useState(null);

  React.useEffect(() => {
    regions.forEach((key) => {
      const element = document.getElementById(key);
      element.classList.add("continent");
      if (data[key] !== undefined && data[key].length > 0) {
        element.addEventListener("click", function () {
          setTargetContinent(key);
        });
        element.addEventListener("mouseenter", function () {
          element.classList.add("--continent-hover");
        });
        element.addEventListener("mouseleave", function () {
          element.classList.remove("--continent-hover");
        });
      }
    });
  }, [setTargetContinent, targetContinent]);

  React.useEffect(() => {
    function updateMapSize() {
      if (!mapRef.current || !containerRef.current) {
        return;
      }

      const { width, height } = containerRef.current.getBoundingClientRect();
      // mapRef.current.style.width = width * 1.25;
      // mapRef.current.style.height = height * 1.25;
    }

    updateMapSize();

    window.addEventListener("resize", updateMapSize);
    return () => window.removeEventListener("resize", updateMapSize);
  }, []);

  React.useEffect(() => {
    let timeoutId = null;

    if (targetContinent) {
      mapRef.current.classList.add("--map-fade");
      timeoutId = setTimeout(() => setContinent(targetContinent), 500);
    }

    return () => clearTimeout(timeoutId);
  }, [targetContinent, setContinent]);

  const mapText =
    "On International Women’s Day, and throughout the year, The Fuller Project produces groundbreaking reporting about women to help create a more equal world. Click on the map to read our stories by region, or on the menu to read them by issue area.";
  return (
    <React.Fragment>
      <div ref={containerRef} className='map-container'>
        {!targetContinent && (
          <div className='map-prompt-wrapper'>
            <span className='map-prompt'>
              <p className='map-text'>{mapText}</p>
            </span>
          </div>
        )}
        <Continents ref={mapRef} />
        <div className='map-menu-container'>
          <h3>FOCUS AREAS</h3>
          <div className='map-menu'>
            <button
              className='menu-button'
              onClick={() => setCategory("climate")}
            >
              Climate & environment
            </button>
            <button
              className='menu-button'
              onClick={() => setCategory("economy")}
            >
              Economy & Labor
            </button>
            <button
              className='menu-button'
              onClick={() => setCategory("health")}
            >
              Health
            </button>
            <button
              className='menu-button'
              onClick={() => setCategory("movement")}
            >
              Movements
            </button>
          </div>
        </div>
        {/* <Regions /> */}
      </div>
      <div className='map-background'>
        <video autoPlay muted loop>
          <source src={`https://fullerproject.org/wp-content/uploads/2024/03/FullerIWD24_3.mp4`} type='video/mp4' />
          {/* <source src="/vidFullerMap_Loop_Blur25_20223.mp44" type="video/webm" /> */}
        </video>
      </div>
    </React.Fragment>
  );
}
